<template>
  <div>
    <el-page-header class="detail-head" @back="goBack">
      <template v-slot:content>
        <div class="toolbar">
          <span>文章详情</span>
          <div class="toolbar-items">
            <el-button size="mini" type="danger" @click="release">发布</el-button>
            <el-button size="mini" type="primary" @click="preview">浏览</el-button>
          </div>
        </div>
      </template>
    </el-page-header>
    <el-divider class="detail-divider"></el-divider>

    <el-tabs model-value="first">
      <el-tab-pane label="基础信息" name="first">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="mainForm" :model="entity" :rules="rules" label-width="80px">
              <el-row :gutter="20">
                <el-col :span="12">
                  <div class="grid-content">
                    <el-form-item label="标题" class="detail-form-item" prop="title">
                      <el-input size="medium" v-model="entity.title" @blur="pinyin"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="排序号" class="detail-form-item">
                      <el-input-number size="medium" v-model="entity.sortNo"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="所属栏目" class="detail-form-item" prop="categoryId">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.categoryId" @change="changeCategory">
                        <el-option v-for="item in parents" :key="item.id" :label="item.name" :value="item.id">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="类型" class="detail-form-item">
                      <el-select class="detail-form-item-select" size="medium" v-model="entity.type">
                        <el-option v-for="item in types" :key="item.itemKey" :label="item.itemValue" :value="item.itemKey">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="红头文件" class="detail-form-item">
                      <el-radio-group v-model="entity.red">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="红头编号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.redCode"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="9">
                  <div class="grid-content">
                    <el-form-item label="链接" class="detail-form-item">
                      <el-input size="medium" v-model="entity.url"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content">
                    <el-button type="text" size="medium" @click="selectCategory">选择栏目</el-button>
                    <el-button type="text" size="medium" @click="selectContent">选择文章</el-button>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="是否发布" class="detail-form-item">
                      <el-radio-group v-model="entity.released">
                        <el-radio :label="true">是</el-radio>
                        <el-radio :label="false">否</el-radio>
                      </el-radio-group>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="发布时间" class="detail-form-item" prop="checkReleaseDate">
                      <el-date-picker v-model="entity.releaseDate" type="datetime" value-format="YYYY-MM-DD HH:mm:ss">
                      </el-date-picker>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content">
                    <el-form-item label="作者" class="detail-form-item">
                      <el-input size="medium" v-model="entity.author"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="编号" class="detail-form-item">
                      <el-input size="medium" v-model="entity.code"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="关键字" class="detail-form-item">
                      <el-input v-model="entity.keyword"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="文章标签" class="detail-form-item">
                      <el-select-v2 :key="refreshKey" ref="selTags" size="medium" v-model="tagValues" :options="tagOptions" clearable multiple style="width:100%" />
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="hasExtend">
                <el-col :span="6" v-for="(item) in generalCustomDetails" :key="item.id">
                  <div class="grid-content">
                    <el-form-item :label="item.label">
                      <el-input v-if="item.type=='text'" v-model="entity.extend[item.name]" size="medium"></el-input>
                      <el-date-picker v-if="item.type=='date'" v-model="entity.extend[item.name]" type="date" value-format="YYYY-MM-DD">
                      </el-date-picker>
                      <el-input-number v-if="item.type=='number'" v-model="entity.extend[item.name]" size="medium"></el-input-number>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20" v-if="hasExtend">
                <el-col :span="24" v-for="(item) in textareaCustomDetails" :key="item.id">
                  <div class="grid-content">
                    <el-form-item :label="item.label">
                      <el-input v-if="item.type=='mtext'" type="textarea" rows="8" v-model="entity.extend[item.name]" size="medium"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="缩略图">
                    <el-upload class="avatar-uploader" action="customize" :auto-upload="true" :show-file-list="false" :http-request="uploadFile">
                      <img v-if="entity.img" :src="entity.img" class="avatar" />
                      <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                    </el-upload>
                  </el-form-item>
                </el-col>
                <el-col :span="18">
                  <div class="grid-content">
                    <el-form-item label="描述" class="detail-form-item">
                      <el-input type="textarea" rows="8" v-model="entity.description" maxlength="1000" show-word-limit></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.creator" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="创建时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.createTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改人" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifier" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="6">
                  <div class="grid-content">
                    <el-form-item label="修改时间" class="detail-form-item">
                      <el-input size="medium" v-model="entity.modifyTime" disabled></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
              <el-row :gutter="20">
                <el-col :span="24">
                  <div class="grid-content">
                    <el-form-item label="备注" class="detail-form-item">
                      <el-input type="textarea" v-model="entity.remark"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
      <el-tab-pane label="文章内容" name="second">
        <div class="detail-containe-product">
          <el-form class="detail-form" ref="fromEditor" :model="entity" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="24">
                <div class="grid-content">
                  <el-form-item label="文章内容" class="detail-form-item" prop="content">
                    <TinymceEditor ref="editor"></TinymceEditor>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="附件列表" name="three">
        <div class="detail-containe-product">
          <el-form class="detail-form" ref="fromFiles" :model="entity" :rules="rules" label-width="100px">
            <el-row :gutter="20">
              <el-col :span="24">
                <el-form-item label="附件列表">
                  <div>
                    <el-button size="mini" type="danger" @click="addRow">增行</el-button>
                  </div>
                  <el-table :data="entity.contentFiles" border style="width: 100%" @row-click="rowClick">
                    <el-table-column prop="no" label="序号" width="50"> </el-table-column>
                    <el-table-column prop="name" label="文件名称" width="380"> </el-table-column>
                    <el-table-column prop="url" label="文件地址"> </el-table-column>
                    <el-table-column prop="size" label="文件大小" width="100"> </el-table-column>
                    <el-table-column label="前台隐藏" width="100">
                      <template #default="scope">
                        <div class="column-tag" v-if="scope.row.edit">
                          <el-checkbox class="item-edit" size="mini" v-model="scope.row.hidden"></el-checkbox>
                        </div>
                        <div class="column-tag" v-else>
                          <el-tag v-if="scope.row.hidden" type="danger" size="mini">是</el-tag>
                          <el-tag v-else size="mini">否</el-tag>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column label="操作" width="180">
                      <template #default="scope">
                        <el-upload class="row-upload" action="customize" :auto-upload="true" :show-file-list="false" :data="scope" :http-request="uploadAccessory">
                          <el-button size="mini" type="primary">上传文件</el-button>
                        </el-upload>
                        <el-button size="mini" type="danger" @click="deleteRow(scope)">删行</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </div>
      </el-tab-pane>
      <el-tab-pane label="手机端内容" name="four">
        <div class="detail-containe-product">
          <el-scrollbar>
            <el-form class="detail-form" ref="fromMobileEditor" :model="entity" :rules="rules" label-width="110px">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <el-form-item label="手机端缩略图">
                        <el-upload class="avatar-uploader" action="customize" :auto-upload="true" :show-file-list="false" :http-request="uploadMobileFile">
                          <img v-if="entity.mobileImg" :src="entity.mobileImg" class="avatar" />
                          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                        </el-upload>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-col>
                <el-col :span="8">
                  <div class="grid-content">
                    <el-form-item label="手机端文章内容" class="detail-form-item">
                      <TinymceMobileEditor ref="mobileEditor" style="width:414px"></TinymceMobileEditor>
                    </el-form-item>
                  </div>
                </el-col>
                <el-col :span="2">
                  <el-button type="primary" size="small" @click="copy">复制电脑端内容</el-button>
                </el-col>
                <el-col :span="8">
                  <div class="grid-content">
                    <el-form-item label="手机端链接" class="detail-form-item">
                      <el-input v-model="entity.mobileUrl"></el-input>
                    </el-form-item>
                  </div>
                </el-col>
              </el-row>
            </el-form>
          </el-scrollbar>
        </div>
      </el-tab-pane>
    </el-tabs>

    <el-divider class="detail-divider"></el-divider>
    <div class="detail-form-item-btns">
      <el-button v-if="edit" size="medium" class="detail-form-item-btn" type="primary" @click="save">保存</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="goBack">返回列表</el-button>
      <el-button size="medium" class="detail-form-item-btn" @click="reset">刷新</el-button>
    </div>
  </div>
  <CategoryRefer ref="categoryRefer"> </CategoryRefer>
  <ContentRefer ref="contentRefer"> </ContentRefer>
</template>

<script lang="ts">
import { Options } from "vue-class-component";
import { BaseDetail } from "@/script/core/view/BaseDetail";
import {
  Category,
  Content,
  Tag,
  ContentFile,
} from "@/script/apps/cms/entity/CmsEntity";
import { ServiceContext, ServiceFactory } from "@/script/core/base/ServiceData";
import { DateUtil } from "@/script/core/util/DateUtil";
import { ContentService } from "@/script/apps/cms/service/ContentService";
import { CategoryService } from "@/script/apps/cms/service/CategoryService";
import TinymceEditor from "@/components/TinymceEditor.vue";
import TinymceMobileEditor from "@/components/TinymceMobileEditor.vue";
import { TagService } from "@/script/apps/cms/service/TagService";
import { AppConfig } from "@/script/core/base/AppConfig";
import { ElMessage } from "element-plus";
import { CallBack } from "@/script/core/service/DataService";
import { Custom, CustomDetail } from "@/script/apps/system/entity/SystemEntity";
import store from "@/store";
import CategoryRefer from "../category/CategoryRefer.vue";
import ContentRefer from "./ContentRefer.vue";

@Options({
  components: {
    TinymceEditor,
    TinymceMobileEditor,
    CategoryRefer,
    ContentRefer,
  },
})
export default class ContentDetail extends BaseDetail {
  public refreshKey = 1;

  public hasExtend = false;

  public parents: Category[] = [];

  public tagValues: number[] = [];

  public tagOptions: any[] = [];

  public customDetails: CustomDetail[] = [];
  public generalCustomDetails: CustomDetail[] = [];
  public textareaCustomDetails: CustomDetail[] = [];

  public service = new ContentService();

  public rules = {
    title: [{ required: true, message: "请输入标题", trigger: "blur" }],
    content: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (this.entity.type === "content") {
            if (this.entity.content === null) {
              callback(new Error("请输入内容"));
            } else if (this.entity.content === undefined) {
              callback(new Error("请输入内容"));
            } else if (this.entity.content === "") {
              callback(new Error("请输入内容"));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: "blur",
      },
    ],
    categoryId: [
      { required: true, message: "请选择所属栏目", trigger: "change" },
    ],
    checkReleaseDate: [
      {
        validator: (rule: any, value: any, callback: any) => {
          if (this.entity.released) {
            if (this.entity.releaseDate === null) {
              callback(new Error("请选择发布时间"));
            } else if (this.entity.releaseDate === undefined) {
              callback(new Error("请选择发布时间"));
            } else {
              callback();
            }
          } else {
            callback();
          }
        },
        trigger: "change",
      },
    ],
  };

  activated() {
    // 强制刷新组件
    this.refreshKey += 1;

    this.tagValues = [];
  }

  public initData(): ServiceContext {
    const data = ServiceFactory.build(
      "biz_cms_content",
      "/cms/content",
      "/cms/content",
      this.service
    );
    data.typesName = "content-type";
    return data;
  }

  public add() {
    this.service.generateCode("cms").then((result: any) => {
      super.add();
      if (this.serviceContext.statesName === "sys-state") {
        this.entity.state = "enable";
      }
      this.entity.code = result.data;
      this.entity.creator = store.getters.loginUser.name;
    });
  }

  public newEntity() {
    const entity: Content = { contentFiles: [], deleteContentFiles: [] };
    const categoryId = this.$route.query.categoryId;
    if (categoryId) {
      entity.categoryId = Number(categoryId);
    }
    if (this.$refs.editor) {
      (this.$refs.editor as TinymceEditor).setContent("");
    }
    if (this.$refs.mobileEditor) {
      (this.$refs.mobileEditor as TinymceMobileEditor).setContent("");
    }
    entity.released = false;
    entity.red = false;
    entity.type = "content";
    entity.sortNo = 0;
    entity.extend = {};
    this.injectDetailData(entity.contentFiles!, entity.deleteContentFiles!);
    this.initExtend(entity);
    return entity;
  }

  public initOptions() {
    super.initOptions();
    const categoryService = new CategoryService();
    categoryService.loadParentCategorys(0, (data: any) => {
      this.parents = data;
    });
    const tagService = new TagService();
    tagService.loadTagsByType("content", (data: any) => {
      const tags: Tag[] = data;
      this.tagOptions = [];
      tags.forEach((item) => {
        this.tagOptions.push({
          value: item.id,
          label: item.name,
        });
      });
    });
  }

  uploadFile(param: any) {
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.img = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  uploadMobileFile(param: any) {
    const path = "mobile/cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        this.entity.mobileImg = uploadUrl;
      },
      (error: Error) => {
        ElMessage.error("上传图片失败！原因：" + error);
      }
    );
  }

  uploadAccessory(param: any) {
    const contentFile = param.data.row as ContentFile;
    const path = "cms";
    const formData = new FormData();
    formData.append("path", path);
    formData.append("files", param.file, param.file.name);
    this.service.uploadFile(formData).then(
      (result) => {
        const uploadUrl =
          AppConfig.Config.ServerUrl + `file/${path}/${result.data}`;
        contentFile.url = uploadUrl;
        contentFile.name = param.file.name;
        contentFile.size = param.file.size;
        contentFile.type = param.file.type;
        this.modifyRow(contentFile);
      },
      (error: Error) => {
        ElMessage.error("上传附件失败！原因：" + error);
      }
    );
  }

  public afterLoad(data: any) {
    (this.$refs.editor as TinymceEditor).setContent(data.content);
    (this.$refs.mobileEditor as TinymceMobileEditor).setContent(
      data.mobileContent
    );
    const content = this.entity as Content;
    content.deleteContentFiles = [];
    this.injectDetailData(content.contentFiles!, content.deleteContentFiles!);
    this.generateRowNo();

    if (content.tagIds) {
      const tempTagValues: number[] = [];
      const stagIds = content.tagIds?.split(",");
      stagIds.forEach((item) => {
        tempTagValues.push(Number(item));
      });
      this.tagValues = tempTagValues;
    } else {
      this.tagValues = [];
    }

    this.initExtend(content);
  }

  private changeCategory() {
    const content = this.entity as Content;
    this.initExtend(content);
  }

  private initExtend(content: Content) {
    if (content.categoryId) {
      this.service.loadEntity(
        "/api/cms/category/entity",
        { id: content.categoryId },
        (data: any) => {
          const category = data as Category;
          if (category.customId) {
            this.hasExtend = true;
            this.loadExtend(category.customId!);
          } else {
            this.customDetails = [];
            this.generalCustomDetails = [];
            this.textareaCustomDetails = [];
            this.hasExtend = false;
          }
        }
      );
    }
  }

  private loadExtend(id: number) {
    this.service.loadEntity("/api/sys/custom/entity", { id }, (data: any) => {
      const custom = data as Custom;
      this.customDetails = custom.customDetails!;
      this.generalCustomDetails = [];
      this.textareaCustomDetails = [];
      if (this.customDetails) {
        this.customDetails.forEach((item) => {
          if (item.type !== "mtext") {
            this.generalCustomDetails.push(item);
          } else {
            this.textareaCustomDetails.push(item);
          }
        });
      }
    });
  }

  private copy() {
    this.entity.content = (this.$refs.editor as TinymceEditor).getContent();
    (this.$refs.mobileEditor as TinymceMobileEditor).setContent(
      this.entity.content
    );
  }

  public beforeSave() {
    this.entity.content = (this.$refs.editor as TinymceEditor).getContent();
    this.entity.mobileContent = (
      this.$refs.mobileEditor as TinymceMobileEditor
    ).getContent();
    this.entity.tagIds = this.tagValues?.join(",");
    this.entity.extendData = JSON.stringify(this.entity.extend);
    return true;
  }

  public afterSave() {
    // this.service.staticize(this.id);
  }

  private release() {
    this.service.release(this.entity).then(
      (result) => {
        if (result.success) {
          ElMessage({ type: "success", message: "发布成功!" });
          this.load(this.id);
        } else {
          ElMessage({ type: "error", message: result.message });
        }
      },
      (error: Error) => {
        ElMessage.error("发布失败，原因：" + error.message);
      }
    );
  }

  private preview() {
    const content = this.entity as Content;
    if (!content.id) {
      ElMessage.error("无法浏览，请您保存后再浏览!");
      return;
    }
    window.open(content.url);
  }

  private pinyin() {
    const content = this.entity as Content;
    this.service.pinyin(content.title!).then((result: any) => {
      content.name = result.data;
    });
  }

  private selectCategory() {
    (this.$refs.categoryRefer as CategoryRefer).show((category: Category) => {
      const content = this.entity as Content;
      content.linkType = "category";
      content.linkId = category.id;
      content.url = category.url;
    });
  }

  private selectContent() {
    (this.$refs.contentRefer as ContentRefer).show((data: Content) => {
      const content = this.entity as Content;
      content.linkType = "content";
      content.linkId = data.id;
      content.url = data.url;
    });
  }
}
</script>

<style lang="scss">
.row-upload {
  display: inline-block;
  margin-right: 10px;
}
</style>
